module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_confirmation", [["div",{"class":"message-popup"},[["div",{"class":"dlg-content message"},[["textNode",{"text":" "}],["span",{},[],[["message","__text",true]]],["textNode",{"text":" "}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/popup/confirmation.tpl
// module id = 258
// module chunks = 2